import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Switch, Row, Col } from 'antd';
import { useArcWeldingFormOptions } from '../../hooks/useArcWeldingFormOptions';
import { AwFormSelect } from './ArcWeldingListShell';
import { AW_FORM_LABELS, AW_MODAL_SECTIONS } from '../../utils/arcWeldingVerificationUi';
import './ArcWelding.css';

const { TextArea } = Input;

const ArcWeldingCriteriaForm = ({ open, initialValues, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();
  const { options } = useArcWeldingFormOptions();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        isActive: true,
        displayOrder: 0,
        ...initialValues,
      });
    } else {
      form.resetFields();
    }
  }, [open, initialValues, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSubmit(values);
  };

  const modalTitle = initialValues?.id ? 'Edit Verification Criterion' : 'New Verification Criterion';

  return (
    <Modal
      className="heatprofile-modal aw-modal-form"
      title={modalTitle}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      width={840}
      destroyOnClose
      centered
      maskClosable={false}
    >
      <Form form={form} layout="vertical" className="aw-modal-form-fields">
        <div className="aw-modal-section-title">{AW_MODAL_SECTIONS.CRITERION}</div>
        <Row gutter={[16, 8]}>
          <Col xs={24} md={12}>
            <Form.Item name="parameter" label={AW_FORM_LABELS.parameter} rules={[{ required: true }]}>
              <AwFormSelect
                options={options.parameter}
                placeholder="Select Parameter"
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="method" label={AW_FORM_LABELS.method} rules={[{ required: true }]}>
              <AwFormSelect
                options={options.method}
                placeholder="Select Method"
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="grade" label={AW_FORM_LABELS.grade} rules={[{ required: true }]}>
              <AwFormSelect
                options={options.grade}
                placeholder="Select Grade"
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="rangeCondition" label={AW_FORM_LABELS.rangeCondition}>
              <Input placeholder="e.g. Low, High, All" />
            </Form.Item>
          </Col>
        </Row>

        <div className="aw-modal-section-title">{AW_MODAL_SECTIONS.TOLERANCE}</div>
        <Row gutter={[16, 8]}>
          <Col xs={24} md={12}>
            <Form.Item name="toleranceType" label={AW_FORM_LABELS.toleranceType}>
              <AwFormSelect
                options={options.toleranceType}
                placeholder="Select Tolerance Type"
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="toleranceValue" label={AW_FORM_LABELS.toleranceValue}>
              <InputNumber placeholder="Value" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="toleranceBasis" label={AW_FORM_LABELS.toleranceBasis}>
              <Input placeholder="Enter Tolerance Basis" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="lowRangeThresholdPct" label={AW_FORM_LABELS.lowRangeThresholdPct}>
              <InputNumber placeholder="%" min={0} max={100} />
            </Form.Item>
          </Col>
        </Row>

        <div className="aw-modal-section-title">{AW_MODAL_SECTIONS.DISPLAY}</div>
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12}>
            <Form.Item name="displayOrder" label={AW_FORM_LABELS.displayOrder}>
              <InputNumber placeholder="0" min={0} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="isActive"
              label={AW_FORM_LABELS.active}
              valuePropName="checked"
              className="aw-form-switch-item"
            >
              <Switch
                className="aw-active-switch"
                checkedChildren="Yes"
                unCheckedChildren="No"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="notes" label={AW_FORM_LABELS.notes}>
              <TextArea rows={3} placeholder="Optional Notes" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ArcWeldingCriteriaForm;
